import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import Resizable from 're-resizable';
import styled from 'styled-components';
import EditLeft from './_EditLeft';
import EditRight from './_EditRight';
import LoadingModal from './_LoadingModal';
import SaveForkModal from './_SaveForkModal';
import SigninModal from './_SigninModal';
import FailedLoadModal from './_FailedLoadModal';

import { getEnvelopeDetails,
         sendToPostOffice,
				 authed, isMine
			 } from './helpers/fireHelper';

const EDITORKEYS = ['jsValue', 'cssValue', 'htmlValue', 'table', 'libraries'];

const Container = styled.div`
	position: absolute;
	top: 70px;
	bottom: 0;
	width: 100%;
`;

const Left = styled.div`
	height: 100%;
	border-right: 1px solid grey;
`;
const Right = styled.div`
	width: auto;
	height: 100%;
	overflow: hidden;
`;

class Edit extends Component {
	constructor() {
		super()
    // const isNew = !props.match.params.key
    // console.log(isNew);
    // const newEv = {
    //   cssValue: "body {\n  font-family: Sans-Serif;\n}\n\ntable {\n  border: 1px solid grey;\n}\n",
    //   htmlValue: "<p>Hi, and welcome to your new envelope! This is a very basic example of an envelope.\nYou can edit the data on the left, and \n  the table below will update automatically.</p>\n<p>Open the tab called \"Javascript\", to see a brief explanation through the steps to building\n   this envelope.</p>\n<p>Good luck!</p>\n<div id=\"table\"></div>\n<p>For developers, the editing environment might seem more familiar. Click on the 'Libs' tab \n  to add a library of your choice. Missing a library? Or any other feature? Let us know, we're happy to hear from you.</p>",
    //   jsValue: "// envelope is the object in which the data in the spreadsheets resides.\n// You can get the data, trimmed to only the fields where data is entered, with \n// the function below. The format is an array of arrays.\nvar data = envelope.trimmedData();\n\n// next, we create a HTML table using a custom function that is defined below.\nvar dataString = createTable(data);\n\n// once we have the table, we simply append it to the div with the id of \"table\"\ndocument.querySelector(\"#table\")\n  .appendChild(dataString)\n\n\n\n\n// function that creates HTML table from array of arrays.\nfunction createTable(tableData) {\n  var table = document.createElement('table');\n  var tableBody = document.createElement('tbody');\n\n  tableData.forEach(function(rowData) {\n    var row = document.createElement('tr');\n\n    rowData.forEach(function(cellData) {\n      if (cellData === null) { cellData = \"\" }\n      var cell = document.createElement('td');\n      cell.appendChild(document.createTextNode(cellData));\n      row.appendChild(cell);\n    });\n\n    tableBody.appendChild(row);\n  });\n\n  table.appendChild(tableBody);\n  return table;\n}\n",
    //   libraries: [],
    //   name: "template",
    //   table: [["Apples","Oranges","Bananas","hoi"],["1","2","3",""]],
    //   tags: "[]"
    // };
    // const newEd = {};
    // EDITORKEYS.forEach(l => {
    //     newEd[l] = JSON.parse(JSON.stringify(newEv[l]));
    //   });
		this.state = {
			counter: 0,
			envelope: null,
			resizeStop: true,
			collapsed: false,
			editor: {},
			promptedForName: false,
			ownershipStatus: 'signedOut',
      activeModal: "",
      deleted: false
		}

		this.editor = {}
    // console.log('HUUH', this.state);
	}
  // componentDidUpdate() {
  //   console.log(JSON.parse(JSON.stringify(this.state.envelope)))
  // }
	componentDidMount() {
		const key = this.props.match.params.key;
		if (typeof key === "undefined") {
			// new
		} else {
			// edit
		}
		this.fetchData(false);
		window.addEventListener("resize", this.windowResized);
		// console.log('STATUSMOUNT:', this.state.ownershipStatus);
	}
	// componentWillr
	fetchData = (retry, counter, method) => {
		const key = this.props.match.params.key;
		if (typeof key !== "undefined") {
			getEnvelopeDetails(key)
				.then(envelope => {
          const activeModal = typeof method === "undefined" ? "" : method;
					const ownershipStatus = authed() ? isMine(envelope.authorId) ? "mine" : "others" : "signedOut"
					const editor = {};
					EDITORKEYS.forEach(l => {
            if (l === 'table' && typeof envelope[l] === 'undefined') {
                editor[l] = [[]];
              } else {
                editor[l] = JSON.parse(JSON.stringify(envelope[l]));
            }
            // console.log(l, envelope[l])
					})
					this.setState({ envelope, editor, ownershipStatus, activeModal })
				})
				.catch(error => {
					if (retry) {
						if (counter > 50) {
              this.setState({ activeModal: "failedload" })
              console.error ("LONG POLLING FAILED");
              return;
            }
						counter += 1;
						window.setTimeout(this.fetchData(true, counter, method), 500)
					}
				})
		} else {
			const envelope = {
        cssValue: "body {\n  font-family: Sans-Serif;\n}\n\ntable {\n  border: 1px solid grey;\n}\n",
        htmlValue: "<p>Hi, and welcome to your new envelope! This is a very basic example of an envelope.\nYou can edit the data on the left, and \n  the table below will update automatically.</p>\n<p>Open the tab called \"Javascript\", to see a brief explanation through the steps to building\n   this envelope.</p>\n<p>Good luck!</p>\n<div id=\"table\"></div>\n<p>For developers, the editing environment might seem more familiar. Click on the 'Libs' tab \n  to add a library of your choice. Missing a library? Or any other feature? Let us know, we're happy to hear from you.</p>",
        jsValue: "// envelope is the object in which the data in the spreadsheets resides.\n// You can get the data, trimmed to only the fields where data is entered, with \n// the function below. The format is an array of arrays.\nvar data = envelope.trimmedData();\n\n// next, we create a HTML table using a custom function that is defined below.\nvar dataString = createTable(data);\n\n// once we have the table, we simply append it to the div with the id of \"table\"\ndocument.querySelector(\"#table\")\n  .appendChild(dataString)\n\n\n\n\n// function that creates HTML table from array of arrays.\nfunction createTable(tableData) {\n  var table = document.createElement('table');\n  var tableBody = document.createElement('tbody');\n\n  tableData.forEach(function(rowData) {\n    var row = document.createElement('tr');\n\n    rowData.forEach(function(cellData) {\n      if (cellData === null) { cellData = \"\" }\n      var cell = document.createElement('td');\n      cell.appendChild(document.createTextNode(cellData));\n      row.appendChild(cell);\n    });\n\n    tableBody.appendChild(row);\n  });\n\n  table.appendChild(tableBody);\n  return table;\n}\n",
        libraries: [],
        name: "template",
        table: [["Apples","Oranges","Bananas"],["1","2","3"]],
        tags: "[]",
        description: ''
      }, editor = {};
			EDITORKEYS.forEach(k => {
				editor[k] = JSON.parse(JSON.stringify(envelope[k]));
			})
			this.setState({ envelope, editor, ownershipStatus: "new" })
      window.setTimeout(this.run, 100);
		}
	}
	windowResized = () => {
		this.run();
	}
	componentWillReceiveProps(nextProps) {
		let status;
		if (!this.state.envelope || typeof this.state.envelope.authorId === "undefined") {
			status = "new"
		} else if (!authed()) {
			status = "signedOut"
		} else if (!isMine(this.state.envelope.authorId)) {
			status = "others"
		} else {
			status = "mine"
		}
		this.setState({ ownershipStatus: status })
	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.windowResized);
	}
	onHotChange = (table, changes, source) => {
		if (source !== "loadData") {
			const envelope = Object.assign(this.state.envelope, { table });
			this.setState({ envelope, counter: this.state.counter + 1 })
		}
	}
	onCodeChange = (data, source, type) => {
		const map = {
			javascript: 'jsValue',
			css: 'cssValue',
			html: 'htmlValue'
		}
		this.editor[map[type]] = data;
		const envelope = Object.assign(this.state.envelope, this.editor);
		this.setState({ envelope })
	}
	onLibsChange = (libraries) => {
		const envelope = Object.assign(this.state.envelope, { libraries })
		this.setState({ envelope });
	}
	onResize = (e) => {
		const envelope = Object.assign(this.state.envelope, this.editor);
		this.setState({ envelope, counter: this.state.counter + 1, resizeStop: false })
	}
	onResizeStop = (e) => {
		this.setState({resizeStop: true})
	}
	run = () => {
		const envelope = Object.assign(this.state.envelope, this.editor);
		this.setState({ envelope, counter: this.state.counter + 1 })
	}
	keyDown = (e) => {
		if (e.keyCode === 13 && (e.metaKey || e.ctrlKey)) { this.run(); }
		if (e.keyCode === 83 && (e.metaKey || e.ctrlKey)) {
			e.preventDefault();
			this.saveEnvelope("save");
		}
	}
	changeName = (e) => {
		const envelope = Object.assign(this.state.envelope, { name: e.target.value });
		this.setState({ envelope })
	}

	changeDescription = (e) => {
		const envelope = Object.assign(this.state.envelope, { description: e.target.value })
		this.setState({ envelope })
	}

	changeTags = (e) => {
		const envelope = Object.assign(this.state.envelope, { tags: JSON.stringify(e) })
		this.setState({ envelope })
	}
	saveEnvelope = (initialMethod) => {
		const copiedEnvelope = JSON.parse(JSON.stringify(this.state.envelope));
		const ev = Object.assign(copiedEnvelope, { isPublic: true })
		if (typeof ev.libraries !== "string") { ev.libraries = JSON.stringify(ev.libraries) }
		if (typeof ev.tags !== "string") { ev.tags = JSON.stringify(ev.tags) }

		const key = this.props.match.params.key;
		const method = typeof key === "undefined" ? "create" : initialMethod === "save" ? "update" : "fork";                              //METHOD

		if (method === "create" && ev.name === "" && !this.state.promptedForName) {
			this.refs.editleft.renderSettingsPopup();
			this.setState({ promptedForName: true })
		} else if (this.state.ownershipStatus === "signedOut") {
      this.setState({ activeModal: "signin" })
    } else {
			sendToPostOffice(method, key, ev)
				.then(res => {
          // console.log('TEST', method, key, ev);
          this.setState({ activeModal: "loading" })
					if (typeof res.key === "undefined") { console.error("POST went wrong"); return; }
					if (method === "update") {
            this.setState({ activeModal: "save", ownershipStatus: "mine" })
            return;
          }
					this.props.history.push('/edit/' + res.key);
					window.setTimeout(() => this.fetchData(true, 0, initialMethod), 500);
				})
			}
	}

	deleteEnvelope = (e) => {
		// console.log('DELETE ENVELOPE...');
    sendToPostOffice("delete", this.props.match.params.key)
      .then(res => {
        // console.log('THEN => ', res);
        this.setState({ deleted: true });
      })
      .catch(res => console.log('CATCH => ', res))
	}

  collapse = () => {
    this.setState({ collapsed: this.state.collapsed ? false : true })
    window.setTimeout(this.run, 100)
  }


  closeModal = (str) => {
    if (this.state.activeModal === str) {
      this.setState({ activeModal: "" });
    }
  }

  render() {
    if (this.state.deleted) { return (
      <Redirect to="/"/>
    )}


////////////////////////////////////////////////////////////////////////////////////////////////////
///  WATCH OUT: TWO SIMILAR COMPNENTS ARE RENDERED IN DIFFERENT CIRCUMSTANCES (COLLAPSED OR NOT) ///
////////////////////////////////////////////////////////////////////////////////////////////////////


		return this.state.collapsed ? (
			<div onKeyDown={this.keyDown}>
        <FailedLoadModal
          closeModal={this.closeModal}
          open={this.state.activeModal === "failedload"}
          method={"failedload"}
        />
        <SigninModal
          signIn={this.props.signIn}
          closeModal={this.closeModal}
          open={this.state.activeModal === "signin"}
          method={"signin"}
        />
				<LoadingModal
          closeModal={this.closeModal}
					open={this.state.activeModal === "loading"}
				/>
        <SaveForkModal
          open={this.state.activeModal === "save" || this.state.activeModal === "fork"}
          closeModal={this.closeModal}
          method={this.state.activeModal}
        />
				<Container>
					<Resizable
						style={{float: 'left'}}
						enable={{}}
						size={{ width: '55px', height:'100%' }}
					>
						<Left>
							<EditLeft
								evKey={this.props.match.params.key}
								ownershipStatus={this.state.ownershipStatus}
								ref="editleft"
								saveEnvelope={() => this.saveEnvelope("save")}
								forkEnvelope={() => this.saveEnvelope("fork")}
								deleteEnvelope={this.deleteEnvelope}
								changeName={this.changeName}
								changeDescription={this.changeDescription}
								changeTags={this.changeTags}
								editor={this.editor}
								envelope={this.state.envelope}
								run={this.run}
								counter={this.state.counter}
								onHotChange={this.onHotChange}
								onCodeChange={this.onCodeChange}
								onLibsChange={this.onLibsChange}
                collapse={this.collapse}
								collapsed={this.state.collapsed}
							/>
						</Left>
					</Resizable>
					<Right><EditRight
            counter={this.state.counter}
						resizeStop={this.state.resizeStop}
						envelope={JSON.parse(JSON.stringify(this.state.envelope))}/></Right>
				</Container>
			</div>
			) : (
			<div  onKeyDown={this.keyDown}>
				<Container>
          <FailedLoadModal
            closeModal={this.closeModal}
            open={this.state.activeModal === "failedload"}
            method={"failedload"}
          />
          <SigninModal
            signIn={this.props.signIn}
            closeModal={this.closeModal}
            open={this.state.activeModal === "signin"}
            method={"signin"}
          />
					<LoadingModal
            closeModal={this.closeModal}
						open={this.state.activeModal === "loading"}
					/>
          <SaveForkModal
            open={this.state.activeModal === "save" || this.state.activeModal === "fork"}
            closeModal={this.closeModal}
            method={this.state.activeModal}
          />
					<Resizable
						style={{float: 'left'}}
						enable={{right: true}}
						defaultSize={{ width: '370px', height:'100%' }}
						onResize={this.onResize}
						onResizeStop={this.onResizeStop}
						minWidth={350}
					>
						<Left>
							<EditLeft
								evKey={this.props.match.params.key}
								ownershipStatus={this.state.ownershipStatus}
								ref="editleft"
                saveEnvelope={() => this.saveEnvelope("save")}
								forkEnvelope={() => this.saveEnvelope("fork")}
								deleteEnvelope={this.deleteEnvelope}
								changeName={this.changeName}
								changeDescription={this.changeDescription}
								changeTags={this.changeTags}
								editor={this.editor}
								envelope={this.state.envelope}
								run={this.run}
								counter={this.state.counter}
								onHotChange={this.onHotChange}
								onCodeChange={this.onCodeChange}
								onLibsChange={this.onLibsChange}
                collapse={this.collapse}
								collapsed={this.state.collapsed}
							/>
						</Left>
					</Resizable>
					<Right><EditRight
						counter={this.state.counter}
						resizeStop={this.state.resizeStop}
						envelope={this.state.envelope}/></Right>
				</Container>
			</div>
		);
  }
}

export default withRouter(Edit);



// WEBPACK FOOTER //
// ./src/_Edit.js